import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import login from './modules/login'
import wishes from './modules/wishes'
import user from './modules/user'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    login,
    wishes,
    user
  }
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js